import { Component, OnInit } from '@angular/core';
import { Item } from 'src/app/components/link/link.component';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {

  projects: Item[] = [
    // { title: 'CoviDES', image: 'Project-InfluSim.png', route: 'projects/InfluSim' },
    { title: 'KSASIM', image: 'Project-KSASIM.png', route: 'projects/KSASIM' },
    { title: 'CovidControl', image: 'Project-CovidControl.png', route: 'projects/CovidControl' },
    { title: 'CovidSIM', image: 'Project-CovidSIM.png', route: 'projects/CovidSIM' },
    { title: 'TOMMI', image: 'Project-TOMMI.PNG', route: 'projects/TOMMI' },
    { title: 'IMAAC', image: 'Project-IMAAC.png', route: 'projects/IMAAC' },
    { title: '4Strep', image: 'Project-4Strept.png', route: 'projects/4Strep' },
    { title: 'Network Meta Analysis', image: 'Project-Network-Meta-Analysis.png', route: 'projects/Network-Meta-Analysis' },
    { title: 'INET-FA2', image: 'Project-INET-FA2.png', route: 'projects/iNET-FA2' },
    { title: 'Hanta-Prediction', image: 'Project-Hanta-Prediction.png', route: 'projects/Hanta-Prediction' },
    { title: 'SIM-STH', image: 'Project-SIM-STH.png', route: 'projects/SIM-STH' },
    { title: 'Schis-2-HIV', image: 'Project-Schis-2-HIV.png', route: 'projects/Schis-2-HIV' },
    { title: 'c.temp|1', image: 'Project-Ctemp1.png', route: 'projects/ctemp1' },
    { title: '4Flu', image: 'Project-4Flu-Sim.png', route: 'projects/4Flu' },
    { title: 'Aktiv gegen Grippe', image: 'Project-Aktiv-gegen-Grippe.png', route: 'projects/Aktiv-gegen-Grippe' },
    { title: 'Q-LAIV-Sim', image: 'Project-Q-LAIV-Sim.png', route: 'projects/Q-LAIV-Sim' },
    { title: 'MenschMikrobe', image: 'Project-MenschMikrobe.png', route: 'projects/MenschMikrobe' },
    { title: 'InfluSim', image: 'Project-InfluSim.png', route: 'projects/InfluSim' },
    { title: 'InterSim', image: 'Project-InterSim.png', route: 'projects/InterSim' },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
